var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 122,
    viewBox: "0 0 172 122",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dog fetch error") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.696 22.341c-7.856 0-14.342 5.787-15.459 13.321-4.535.464-8.073 4.29-8.073 8.94 0 4.964 4.029 8.988 9.002 8.988h62.453c8.48 0 15.353-6.863 15.353-15.331 0-8.467-6.873-15.331-15.353-15.331-1.141 0-2.249.133-3.318.368.003-.155.012-.309.012-.465C68.313 10.536 58.331.57 46.018.57c-12.148 0-22.022 9.706-22.322 21.771z",
    id: "a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.09.91a1.52 1.52 0 0 0 .312 2.128l6.13 4.556c-2.395.166-4.069.898-4.178.946a1.517 1.517 0 0 0-.768 2.003 1.525 1.525 0 0 0 2.007.775c.032-.013 3.3-1.407 6.871-.264.593.19 1.372.592 2.264 1.134l.05.03c3.933 2.404 10.058 7.531 12.525 9.701a1.524 1.524 0 0 0 2.528-1.203 1.504 1.504 0 0 0-.515-1.079c-.945-.831-7.915-6.913-12.863-9.95L3.221.597a1.517 1.517 0 0 0-.907-.299c-.465 0-.925.211-1.224.612z",
    id: "c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.435 7.432v17.457h6.99c0-3.651-3.604-3.383-3.604-3.383V.313L.435 7.432z",
    id: "e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.061 4.769a10.06 10.06 0 0 0-2.51 6.647v8.58a2.838 2.838 0 0 0 2.842 2.836h17.951s-.095-3.515-3.046-3.515h-7.906s8.521-.813 6.474-9.101C14.817 1.927 6.813.503 6.813.503L3.061 4.769z",
    id: "g"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.329.673A1.744 1.744 0 0 0 .15 2.844c.038.128 3.659 11.723 17.38 11.723 1.384 0 2.871-.119 4.467-.378a1.747 1.747 0 1 0-.562-3.447C7.107 13.075 3.641 2.302 3.501 1.85A1.747 1.747 0 0 0 1.329.673z",
    id: "i"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.944 2.435v7.976L7.35 20.708A29.46 29.46 0 0 0 .506 39.584s6.095 5.215 13.774-3.895c5.416-6.423 9.194-6.977 12.851-9.257v17.457h6.989c0-3.651-3.604-3.383-3.604-3.383V24.983c.252-.354 1.259-2.456 1.5-2.871C36.15 14.939 22.712.962 22.712.962l-6.768 1.473z",
    id: "k"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.506 17.092v2.904a2.838 2.838 0 0 0 2.84 2.836h17.952s-.095-3.515-3.045-3.515h-7.907s8.521-.813 6.473-9.101C14.772 1.927 6.767.503 6.767.503A25.117 25.117 0 0 0 .506 17.092z",
    id: "m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.944.579L.899 6.456c4.035 4.053 14.003.782 14.582-5.877H5.944z",
    id: "o"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.043 10.194l6.009 9.859 6.391-3.883c5.453-3.313 7.184-10.413 3.866-15.859L.043 10.194z",
    id: "q"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.622 3.151l2.48 11.799C7.215 11.318 8.262 5.159 5.309.312L.622 3.151z",
    id: "s"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.454.872a.793.793 0 1 0 .003-.001l-.003.001z",
    id: "u"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.126 4.574l4.894 8.032a3.833 3.833 0 0 0 5.262 1.279 3.821 3.821 0 0 0 1.28-5.254L6.667.6.126 4.574z",
    id: "w"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.358 0C.607 0 0 .897 0 2c0 1.104.607 2 1.358 2h13.286C15.394 4 16 3.104 16 2c0-1.103-.607-2-1.356-2H1.358z",
    id: "y"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A",
    d: "M.194 1.656l3.375.972L2.385.33z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.642 38.979l-5.7 42.132a25.376 25.376 0 0 0-.251 2.107c-.71 9.397.31 24.014-.858 37.231-.038.423-1.47.746-1.988.746H95.528c-.615 0 .918-.451 1.019-.947l7.047-31.227c.254-1.233.025-2.497-.662-3.615 0 0-20.703-33.777-20.81-33.825-2.751-1.254-3.855-1.159-2.142-3.498 1.717-2.345 4.976.76 7.745 1.991.364.163 10.983 19.471 17.15 26.898.514.618 1.685.399 1.812-.341l6.393-37.158",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.642 38.979l-5.7 42.132a25.376 25.376 0 0 0-.251 2.107c-.71 9.397.31 24.014-.858 37.231-.038.423-1.47.746-1.988.746H95.528c-.615 0 .918-.451 1.019-.947l7.047-31.227c.254-1.233.025-2.497-.662-3.615 0 0-20.703-33.777-20.81-33.825-2.751-1.254-3.855-1.159-2.142-3.498 1.717-2.345 4.976.76 7.745 1.991.364.163 10.983 19.471 17.15 26.898.514.618 1.685.399 1.812-.341l6.393-37.158",
    stroke: "#3A4953",
    strokeWidth: 1.58
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56 .68)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BECBCF",
    mask: "url(#b)",
    d: "M-4.836 58.59h96.809V-4.431H-4.836z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.236 36.342c1.118-7.534 7.604-13.32 15.46-13.32l.04.001c.26-12.068 10.133-21.773 22.281-21.773 12.314 0 22.295 9.966 22.295 22.261 0 .155-.009.31-.012.465a15.37 15.37 0 0 1 3.318-.368c8.48 0 15.354 6.864 15.354 15.331 0 8.467-6.874 15.331-15.354 15.331H65.166c-4.973 0-9.002-4.024-9.002-8.989 0-4.649 3.538-8.475 8.072-8.939z",
    stroke: "#3A4953",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61 18.68)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    mask: "url(#d)",
    d: "M-4.211 27.299h38.043V-4.703H-4.211z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#3A4953",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.09 19.59a1.521 1.521 0 0 0 .312 2.128l6.13 4.556c-2.394.167-4.07.898-4.178.946a1.517 1.517 0 0 0-.768 2.003 1.528 1.528 0 0 0 2.007.776c.032-.014 3.3-1.409 6.872-.265.592.19 1.37.591 2.263 1.133l.05.031c3.933 2.404 10.058 7.531 12.525 9.701a1.525 1.525 0 0 0 2.528-1.203 1.507 1.507 0 0 0-.514-1.079c-.946-.832-7.915-6.914-12.864-9.95l-12.232-9.09a1.527 1.527 0 0 0-2.131.312z",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 121.245l171.809-.128"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47 95.68)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D6E4EF",
    mask: "url(#f)",
    d: "M-4.564 29.889h16.989V-4.686H-4.564z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.436 103.113v17.456h6.989c0-3.65-3.603-3.383-3.603-3.383V95.994l-3.386 7.119z",
    stroke: "#3A4953",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22 97.68)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D6E4EF",
    mask: "url(#h)",
    d: "M-4.448 27.832h30.792V-4.497H-4.448z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.865 107.896c-2.048-8.29-10.053-9.713-10.053-9.713l-3.752 4.266a10.062 10.062 0 0 0-2.508 6.646v8.58a2.837 2.837 0 0 0 2.84 2.837h17.952s-.095-3.515-3.046-3.515h-7.907s8.522-.813 6.474-9.101z",
    stroke: "#3A4953",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 102.68)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D6E4EF",
    mask: "url(#j)",
    d: "M-4.924 19.567h33.389V-4.4H-4.924z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.53 117.246c-13.722 0-17.342-11.594-17.38-11.722a1.747 1.747 0 0 1 1.178-2.171 1.747 1.747 0 0 1 2.173 1.177c.14.453 3.606 11.224 17.934 8.892a1.743 1.743 0 0 1 2.006 1.443c.155.952-.49 1.85-1.444 2.004-1.596.26-3.083.377-4.467.377z",
    stroke: "#3A4953",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18 76.68)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D6E4EF",
    mask: "url(#l)",
    d: "M-4.494 48.889H39.12V-4.038H-4.494z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.12 120.569c0-3.65-3.604-3.383-3.604-3.383v-15.523c.252-.354 1.26-2.455 1.5-2.871 4.134-7.172-9.303-21.15-9.303-21.15l-6.769 1.473v7.975L25.35 97.387a29.465 29.465 0 0 0-6.844 18.877s6.094 5.215 13.774-3.895c5.415-6.423 9.194-6.977 12.851-9.256v17.456h6.99z",
    stroke: "#3A4953",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18 97.68)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "n",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    mask: "url(#n)",
    d: "M-4.494 27.832h30.792V-4.497H-4.494z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.82 107.896c-2.049-8.29-10.053-9.713-10.053-9.713a25.112 25.112 0 0 0-6.26 16.589v2.904a2.838 2.838 0 0 0 2.84 2.836h17.951s-.095-3.515-3.045-3.515h-7.907s8.521-.813 6.473-9.101z",
    stroke: "#3A4953",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28 86.68)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "p",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    mask: "url(#p)",
    d: "M-4.101 13.233H20.48V-4.42H-4.101z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29 93c4.15 4.38 14.405.96 15-6H34l-5 6z",
    stroke: "#3A4953",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31 60.68)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "r",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D6E4EF",
    mask: "url(#r)",
    d: "M-4.957 25.053h27.952V-4.689H-4.957z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.443 76.85l-6.392 3.883-6.008-9.859 16.265-9.883c3.32 5.446 1.588 12.546-3.865 15.859z",
    stroke: "#3A4953",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42 60.68)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "t",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    mask: "url(#t)",
    d: "M-4.378 19.95h16.373V-4.689H-4.378z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.622 63.83l4.687-2.838c2.954 4.848 1.906 11.007-2.208 14.639l-2.479-11.8z",
    stroke: "#3A4953",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37 67.68)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "v",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3A4953",
    mask: "url(#v)",
    d: "M-4.34 7.458H7.25V-4.129H-4.34z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27 68.68)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "x",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D6E4EF",
    mask: "url(#x)",
    d: "M-4.874 19.443H17.12V-4.4H-4.874z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.281 82.565a3.82 3.82 0 0 0 1.281-5.254l-4.895-8.031-6.54 3.974 4.893 8.032a3.832 3.832 0 0 0 5.261 1.279z",
    stroke: "#3A4953",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 84)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "z",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E6663C",
    mask: "url(#z)",
    d: "M-5 12h26V-6H-5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47 84H33c-.394 0-1 .896-1 2 0 1.106.606 2 1 2h14c.393 0 1-.894 1-2 0-1.104-.607-2-1-2z",
    stroke: "#3A4953",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45 60.68)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "B",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3A4953",
    mask: "url(#B)",
    d: "M-4.807 7.628H8.568V-4.67H-4.807z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M77.777 37.966a8.239 8.239 0 1 1 16.254 2.706 8.239 8.239 0 0 1-16.254-2.706",
    fill: "#BECBCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.752 42.124c0-6.708 5.446-12.146 12.165-12.146",
    stroke: "#3A4953",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLost);
export default __webpack_public_path__ + "static/media/lost.9688eda1665c2a4d847da815617086a0.svg";
export { ForwardRef as ReactComponent };